module.exports = __webpack_public_path__ + "static/media/20150508_632870_571715.6ac83ec7.mp3";